import React from "react";
import Home from "../components/Home/Home";
import Sidebar from "../components/sidebar/Sidebar";

const HomePage = () => {
  return (
    <div>
      <Sidebar />
      <Home />
    </div>
  );
};

export default HomePage;
